import React, {Component, ReactElement, ReactNode} from 'react'
import NatAdminUserRepo, {PutAdminUserParams} from './repository/NatAdminUserRepo'
import {NatPutAdminUser} from './repository/NatPutAdminUser'
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {CondominiumInfo} from '../condominium/repository/NatGetCondominiumList'
import {ResidentUserInfo} from '../roomToResident/repository/NatGetRoomToResident'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatOwnerCondominiumRepo from '../ownerCondominium/repository/NatOwnerCondominiumRepo'
import {
    AVAILABLE_OR_NOT,
    DO_OR_NOT,
    MESSAGE_TYPE,
    ROLE_FOR_ADMINISTRATOR,
    SELECT_CONDOMINIUM_TYPE,
    SELECT_USER_TYPE,
} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import NatCondominiumSelectionComponent from '../common/admin/NatCondominiumSelectionComponent'
import NatResidentUserSelectionComponent from '../common/admin/NatResidentUserSelectionComponent'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import PPInput from '../../../components/shared/forms/PPInput'
import styled from 'styled-components'
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {AdminUserData, NatGetAdminUser} from './repository/NatGetAdminUser'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {formatForDateInput, formatForDateInputFromDate} from '../../../formatters/formatDate'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {NatGetOwnerCondominium, RoomToResident} from '../ownerCondominium/repository/NatGetOwnerCondominium'
import PPErrorDisplayButton from '../../../components/shared/forms/PPErrorDisplayButton'
import {ConditionTableFixed} from '../../../styledComponents/adminPage/ConditionTable'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import moment from 'moment'
import {AdminUserRelatedCondominiumGroup} from './repository/AdminUserRelatedCondominiumGroup'
import {Box, TableBody, TableCell, TableRow} from '@mui/material';
import {Warning} from '../common/admin/NatAcceptedWarning'
import {NatGetAzureADUser} from './repository/NatGetAzureADUser'
import NatAdminCommonAcceptedWarningComponent from '../common/admin/NatAdminCommonAcceptedWarningComponent'
import {Location} from 'react-router-dom'
import {autoKanaOnUpdate} from '../../common/util/Natutil'

const PASSWORD_PLACEHOLDER: string = '●●●●●●●●●●'

const KEY_LOGIN_USER_ADMIN_ID: string = 'loginUserAdminId'
const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'
const KEY_LOGIN_USER_CONDOMINIUM_GROUP_NAME: string = 'loginUserCondominiumGroupName'
const KEY_LOGIN_USER_FIRST_NAME: string = 'loginUserAdminFirstName'
const KEY_LOGIN_USER_FAMILY_NAME: string = 'loginUserAdminFamilyName'

interface Props {
    adminId: string
    condominiumRepo: NatCondominiumRepo
    adminUserRepo: NatAdminUserRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    ridgeRepo: NatRidgeRepo
    roomToResidentRepo: NatRoomToResidentRepo
    ownerCondominiumRepo: NatOwnerCondominiumRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    condominiumGroup: NatGetCondominiumGroup
    loginId: string
    roleId: string
    password: string
    passwordConfirm: string
    loginAvailability: string
    termStartDate: string
    termEndDate: string
    maxTermStartDate: string
    minTermEndDate: string
    mailAddressValue: string
    familyNameValue: string
    firstNameValue: string
    familyNameKanaValue: string
    firstNameKanaValue: string
    isLoadCompleted: boolean
    dialogOpenSelectCondominium: boolean
    dialogOpenSelectResidentUser: boolean
    selectedCondominiumCd: string
    selectedCondominiumName: string
    selectedResidentUserInfo: ResidentUserInfo
    registeredAdminUserData: AdminUserData
    selectedCondominiumGroupId: Nullable<number>
    selectedCondominiumGroupName: Nullable<string>
    selectedRoomToResidentInfos: RoomToResident[]
    handoverCondominiumGroupId: Nullable<number>
    handoverCondominiumGroupName: Nullable<string>
    endDateOfHandover: Nullable<Date>
    setHandoverCondominiumGroup: Nullable<string>
    loginUserCondominiumGroupId: number | null
    currentDate: Nullable<moment.Moment>
    warning: Warning[]
    warningChecked: boolean
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
}

class NatAdminAdminUserEditPage extends Component<Props & AdminPagePropsSet, States> {

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const loginUserCondominiumGroupId
            = SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)
        this.state = {
            condominiumGroup: {
                ['details']: null,
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            loginId: '',
            roleId: '',
            password: '',
            passwordConfirm: '',
            loginAvailability: '',
            termStartDate: '',
            termEndDate: '',
            maxTermStartDate: '',
            minTermEndDate: '',
            mailAddressValue: '',
            familyNameValue: '',
            firstNameValue: '',
            familyNameKanaValue: '',
            firstNameKanaValue: '',
            isLoadCompleted: false,
            dialogOpenSelectCondominium: false,
            dialogOpenSelectResidentUser: false,
            selectedCondominiumCd: '',
            selectedCondominiumName: '',
            selectedResidentUserInfo: {
                sutekiNetId: '',
                seq: 0,
                ridgeCd: '',
                ridgeName: '',
                roomNumber: '',
                familyName: '',
                firstName: '',
                adminFamilyName: '',
                adminFirstName: '',
                parentAdminFamilyName: '',
                parentAdminFirstName: '',
                roleName: '',
                mailAddressPc: '',
                mailAddressMb: '',
                parentFamilyName: '',
                parentFirstName: '',
                status: '',
                updateDatetime: '',
                condominiumGroupName: '',
                condominiumCd: '',
                condominiumName: '',
            },
            registeredAdminUserData: {
                adminId: '',
                loginId: '',
                sutekiNetId: '',
                familyName: '',
                firstName: '',
                familyNameKana: '',
                firstNameKana: '',
                roleId: '',
                roleName: '',
                condominiumGroupId: 0,
                condominiumGroupName: '',
                condominiumCd: '',
                condominiumName: '',
                mailAddressPc: '',
                mailAddressMb: '',
                termStartDate: '',
                termEndDate: '',
                loginAvailability: '',
                version: 0,
                updateDatetime: '',
            },
            selectedCondominiumGroupId: null,
            selectedCondominiumGroupName: null,
            selectedRoomToResidentInfos: [],
            handoverCondominiumGroupId: null,
            handoverCondominiumGroupName: null,
            endDateOfHandover: null,
            setHandoverCondominiumGroup: null,
            loginUserCondominiumGroupId: loginUserCondominiumGroupId,
            currentDate: null,
            warning: [],
            warningChecked: false,
            convertFamilyNameKana: '',
            preFamilyNameKana: '',
            convertFirstNameKana: '',
            preFirstNameKana: '',
        }

        this.handleClickPutCancel = this.handleClickPutCancel.bind(this)
        this.handleClickPutOk = this.handleClickPutOk.bind(this)
        this.putAdminUserButton = this.putAdminUserButton.bind(this)
        this.handleChangeSelectedCondominiumInfo = this.handleChangeSelectedCondominiumInfo.bind(this)
        this.handleChangeSelectedResidentUserInfo = this.handleChangeSelectedResidentUserInfo.bind(this)
        this.handleChangeLoginId = this.handleChangeLoginId.bind(this)
        this.handleChangePassword = this.handleChangePassword.bind(this)
        this.handleChangePasswordConfirm = this.handleChangePasswordConfirm.bind(this)
        this.handleChangeMailAddress = this.handleChangeMailAddress.bind(this)
        this.handleChangeRole = this.handleChangeRole.bind(this)
        this.handleChangeSetHandoverCondominiumGroup = this.handleChangeSetHandoverCondominiumGroup.bind(this)
        this.handleChangeHandoverCondominiumGroupId = this.handleChangeHandoverCondominiumGroupId.bind(this)
        this.handleChangeEndDateOfHandover = this.handleChangeEndDateOfHandover.bind(this)
        this.handleChangeFamilyName = this.handleChangeFamilyName.bind(this)
        this.handleChangeFirstName = this.handleChangeFirstName.bind(this)
        this.handleChangeFamilyNameKana = this.handleChangeFamilyNameKana.bind(this)
        this.handleChangeFirstNameKana = this.handleChangeFirstNameKana.bind(this)
        this.handleChangeLoginAvailability = this.handleChangeLoginAvailability.bind(this)
        this.handleChangeTermStartDate = this.handleChangeTermStartDate.bind(this)
        this.handleChangeTermEndDate = this.handleChangeTermEndDate.bind(this)
        this.handleChangeSelectedCondominiumGroupId = this.handleChangeSelectedCondominiumGroupId.bind(this)
        this.handleOpenCondominiumSelectionDialog = this.handleOpenCondominiumSelectionDialog.bind(this)
        this.handleOpenResidentUserSelectionDialog = this.handleOpenResidentUserSelectionDialog.bind(this)
        this.closeSelectCondominiumDiaLog = this.closeSelectCondominiumDiaLog.bind(this)
        this.closeSelectResidentUserDiaLog = this.closeSelectResidentUserDiaLog.bind(this)
        this.renderSelectedCondominiumInfo = this.renderSelectedCondominiumInfo.bind(this)
        this.renderSelectedResidentUserInfo = this.renderSelectedResidentUserInfo.bind(this)
        this.changeAcceptedWarnings = this.changeAcceptedWarnings.bind(this)
        this.getAzureADUser = this.getAzureADUser.bind(this)
        this.onCompositionStartFamilyName = this.onCompositionStartFamilyName.bind(this)
        this.onCompositionUpdateFamilyName = this.onCompositionUpdateFamilyName.bind(this)
        this.onCompositionStartFirstName = this.onCompositionStartFirstName.bind(this)
        this.onCompositionUpdateFirstName = this.onCompositionUpdateFirstName.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 物件グループマスタ取得
            const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (!condominiumGroupResponse?.details) {
                return
            }

            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (currentDateTime === null || currentDateTime.details === null) {
                return
            }

            // 管理者ユーザ取得
            const adminUserResponse: Nullable<NatGetAdminUser> = await this.props.asyncCallFunction(
                this.props.adminUserRepo.getAdminUser.bind(this.props.adminUserRepo, this.props.adminId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (!adminUserResponse?.details) {
                return
            }

            const adminUser = adminUserResponse.details
            this.setState({
                condominiumGroup: condominiumGroupResponse,
                loginId: adminUser.loginId,
                roleId: adminUser.roleId,
                mailAddressValue: (adminUser.mailAddressPc
                    ? adminUser.mailAddressPc : adminUser.mailAddressMb) ?? '',
                loginAvailability: adminUser.loginAvailability,
                registeredAdminUserData: adminUser,
                familyNameValue: adminUser.familyName ?? '',
                firstNameValue: adminUser.firstName ?? '',
                familyNameKanaValue: adminUser.familyNameKana ?? '',
                firstNameKanaValue: adminUser.firstNameKana ?? '',
                termStartDate: adminUser.termStartDate ?? '',
                termEndDate: adminUser.termEndDate ?? '',
                selectedCondominiumCd: adminUser.condominiumCd ?? '',
                selectedCondominiumName: adminUser.condominiumName ?? '',
                selectedCondominiumGroupId: adminUser.condominiumGroupId,
                selectedCondominiumGroupName: adminUser.condominiumGroupName,
                currentDate: moment(currentDateTime.details.currentDateTime),
            })

            if (adminUser.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
                this.props.navigate(`/admin/error`, {state: {message: Messages.ESYCC0025.toString()}})
                return
            }

            if (adminUser.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value) {
                const adminUserHandoverCondominiumGroup: Nullable<AdminUserRelatedCondominiumGroup>
                    = await this.props.asyncCallFunction(
                    this.props.adminUserRepo.getAdminUserRelatedCondominiumGroup.bind(
                        this.props.adminUserRepo, this.props.adminId,
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

                if (adminUserHandoverCondominiumGroup &&
                    adminUserHandoverCondominiumGroup.endDateOfSubCondominiumGroup) {

                    const currenDate = new Date(currentDateTime.details.currentDateTime)
                    const EndDateOfHandover
                        = new Date(adminUserHandoverCondominiumGroup.endDateOfSubCondominiumGroup)

                    if (currenDate.getFullYear() > EndDateOfHandover.getFullYear()
                        || (currenDate.getFullYear() === EndDateOfHandover.getFullYear()
                            && currenDate.getMonth() > EndDateOfHandover.getMonth())) {
                        this.setState({
                            setHandoverCondominiumGroup: DO_OR_NOT.NOT.value,
                        })
                    } else {
                        this.setState({
                            handoverCondominiumGroupId: adminUserHandoverCondominiumGroup.subCondominiumGroupId,
                            handoverCondominiumGroupName: adminUserHandoverCondominiumGroup.subCondominiumGroupName,
                            endDateOfHandover:
                                new Date(adminUserHandoverCondominiumGroup.endDateOfSubCondominiumGroup),
                            setHandoverCondominiumGroup: DO_OR_NOT.DO.value,
                        })
                    }
                } else {
                    this.setState({
                        setHandoverCondominiumGroup: DO_OR_NOT.NOT.value,
                    })
                }
            }

            // ロールが管理組合役員
            // かつ、素敵ネットIDと物件コードが設定されている場合、居住者ユーザ取得
            if (adminUser.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value &&
                adminUser.sutekiNetId && adminUser.condominiumCd) {

                const ownerCondominiumInfos: Nullable<NatGetOwnerCondominium> =
                    await this.props.asyncCallFunction(
                        this.props.ownerCondominiumRepo.getOwnerCondomoinum.bind(
                            this.props.ownerCondominiumRepo,
                            adminUser.sutekiNetId,
                            adminUser.condominiumCd,
                        ),
                        (httpErrorOrNetworkError) => {
                            this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                        },
                    )
                if (!ownerCondominiumInfos?.details?.roomToResident) {
                    return
                }

                const selectedResidentUserInfo: ResidentUserInfo = {
                    sutekiNetId: adminUser.sutekiNetId,
                    seq: 0,
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: adminUser.familyName,
                    firstName: adminUser.firstName,
                    adminFamilyName: '',
                    adminFirstName: '',
                    parentAdminFamilyName: '',
                    parentAdminFirstName: '',
                    roleName: '',
                    mailAddressPc: '',
                    mailAddressMb: '',
                    parentFamilyName: '',
                    parentFirstName: '',
                    status: '',
                    updateDatetime: '',
                    condominiumGroupName: '',
                    condominiumCd: '',
                    condominiumName: '',
                }

                this.setState({
                    selectedRoomToResidentInfos: ownerCondominiumInfos.details.roomToResident,
                    selectedResidentUserInfo: selectedResidentUserInfo,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    handleClickPutCancel(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleClickPutOk(): Promise<void> {
        this.props.eventEmitter.closeDialog()

        if (this.state.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value &&
            !this.state.mailAddressValue &&
            !this.state.warningChecked) {
            this.setState({
                warning: [
                    {
                        messageId: Messages.WADMA0001.toStringWithId(),
                        message: Messages.WADMA0001.toString(),
                    },
                ],
            })
            return
        }

        await this.props.eventEmitter.showLoading()

        const putAdminUserParams: PutAdminUserParams = {
            adminId: this.props.adminId,
            roleId: this.state.roleId,
            loginId: this.state.loginId,
            mailAddress: this.state.mailAddressValue,
            familyName: this.state.familyNameValue,
            firstName: this.state.firstNameValue,
            familyNameKana: this.state.familyNameKanaValue,
            firstNameKana: this.state.firstNameKanaValue,
            termStartDate: this.state.termStartDate,
            termEndDate: this.state.termEndDate,
            loginAvailability: this.state.loginAvailability,
            condominiumCd: this.state.selectedCondominiumCd,
            sutekiNetId: (this.state.selectedResidentUserInfo.sutekiNetId) ?
                this.state.selectedResidentUserInfo.sutekiNetId : null,
            handoverCondominiumGroupId: this.state.handoverCondominiumGroupId,
            endDateOfHandoverPeriod: this.state.endDateOfHandover
                ? formatForDateInputFromDate(this.state.endDateOfHandover)
                : null,
            version: String(this.state.registeredAdminUserData.version),
        }

        if (this.state.selectedCondominiumGroupId) {
            putAdminUserParams.condominiumGroupId = this.state.selectedCondominiumGroupId
        }
        if (this.state.password) {
            putAdminUserParams.password = this.state.password
        }
        if (this.state.passwordConfirm) {
            putAdminUserParams.passwordConfirm = this.state.passwordConfirm
        }

        if (this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            putAdminUserParams.familyName = null
            putAdminUserParams.firstName = null
        }

        try {
            const putAdminUserResponse: Nullable<NatPutAdminUser> = await this.props.asyncCallFunction(
                this.props.adminUserRepo.putAdminUser.bind(this.props.adminUserRepo, putAdminUserParams),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0002.toString('管理者ユーザ')},
            )
            if (putAdminUserResponse && putAdminUserResponse.requestError === null) {

                // 更新対象の管理者がログインユーザの場合、sessionStrageを更新する
                const loginUserAdminId: string | null =
                    SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ADMIN_ID)
                if (this.props.adminId === loginUserAdminId) {
                    SessionStorageHelper.setItem(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID,
                        this.state.selectedCondominiumGroupId ? this.state.selectedCondominiumGroupId : '')
                    SessionStorageHelper.setItem(KEY_LOGIN_USER_CONDOMINIUM_GROUP_NAME,
                        this.state.selectedCondominiumGroupName ? this.state.selectedCondominiumGroupName : '')
                    if (this.state.roleId !== ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
                        SessionStorageHelper.setItem(KEY_LOGIN_USER_FAMILY_NAME, this.state.familyNameValue)
                        SessionStorageHelper.setItem(KEY_LOGIN_USER_FIRST_NAME, this.state.firstNameValue)

                    } else {
                        SessionStorageHelper.setItem(
                            KEY_LOGIN_USER_FAMILY_NAME, this.state.selectedResidentUserInfo.familyName
                                ? this.state.selectedResidentUserInfo.familyName : '')
                        SessionStorageHelper.setItem(
                            KEY_LOGIN_USER_FIRST_NAME, this.state.selectedResidentUserInfo.firstName
                                ? this.state.selectedResidentUserInfo.firstName : '')

                    }
                }
                this.props.navigate(
                    `/admin/adminUser/${this.props.adminId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0008.toString('管理者ユーザ'),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    async getAzureADUser(): Promise<void> {
        const {loginId} = this.state
        await this.props.eventEmitter.showLoading()

        try {
            const response: Nullable<NatGetAzureADUser> = await this.props.asyncCallFunction(
                this.props.adminUserRepo.getAzureADUser.bind(this.props.adminUserRepo, loginId),
                async (httpErrorOrNetworkError) => {
                    const requestItemErrors = httpErrorOrNetworkError.responseBody.requestItemErrors
                    requestItemErrors.forEach((item) => {
                        this.props.eventEmitter.emit(item.resultCode, item)
                    })
                },
            )
            if (response && response.details) {
                this.setState({
                    mailAddressValue: response.details.mailAddress,
                    familyNameValue: response.details.familyName.substr(0, 10),
                    firstNameValue: response.details.firstName.substr(0, 10),
                    familyNameKanaValue: '',
                    firstNameKanaValue: '',
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 登録ボタン押下
    async putAdminUserButton(): Promise<void> {

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('管理者ユーザ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleClickPutCancel,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleClickPutOk,
                    },
                ],
            },
        )
    }

    judgementDispPutAdminUserButton(): boolean {

        const {
            loginId,
            roleId,
            familyNameValue,
            firstNameValue,
            loginAvailability,
            selectedCondominiumCd,
            selectedCondominiumGroupId,
            selectedRoomToResidentInfos,
            setHandoverCondominiumGroup,
            endDateOfHandover,
            warning,
            warningChecked,
        } = this.state

        // 全権限共通
        // 必須項目：[権限],[物件グループ],[管理者ID],[ログイン可否]
        if (roleId === ''
            || selectedCondominiumGroupId === null
            || loginId === ''
            || loginAvailability === '') {
            return true
        }

        // 管理組合役員以外
        // 必須項目：[氏名（姓）],[氏名（名）]
        if (roleId !== ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            if (familyNameValue === '' || firstNameValue === '') {
                return true
            }
        }

        // ライフマネージャ、コンシェルジュ、管理組合役員
        // 必須項目：[物件コード]
        if ((roleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
            roleId === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value ||
            roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) && !selectedCondominiumCd
        ) {
            return true
        }

        // 管理組合役員のみ
        // 必須項目：[居住者ユーザ]
        if (roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            if (selectedRoomToResidentInfos.length === 0) {
                return true
            }
        }

        if (roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value) {
            if (setHandoverCondominiumGroup === DO_OR_NOT.DO.value
                && !endDateOfHandover) {
                return true
            }
        }

        if (warning.length > 0 && !warningChecked) {
            return true
        }

        // 登録ボタンを表示させる
        return false
    }

    handleChangeLoginId(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({loginId: event.target.value})
    }

    handleChangeMailAddress(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({mailAddressValue: event.target.value, warning: [], warningChecked: false})
    }

    handleChangePassword(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({password: event.target.value})
    }

    handleChangePasswordConfirm(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({passwordConfirm: event.target.value})
    }

    handleChangeRole(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({roleId: event.target.value, warning: [], warningChecked: false})
        if (event.target.value === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            this.setState({
                familyNameValue: '',
                firstNameValue: '',
                familyNameKanaValue: '',
                firstNameKanaValue: '',
                setHandoverCondominiumGroup: null,
                handoverCondominiumGroupId: null,
                handoverCondominiumGroupName: null,
                endDateOfHandover: null,
            })
        }
        if (event.target.value === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
            event.target.value === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value) {
            this.setState({
                selectedResidentUserInfo: {
                    sutekiNetId: '',
                    seq: 0,
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    adminFamilyName: '',
                    adminFirstName: '',
                    parentAdminFamilyName: '',
                    parentAdminFirstName: '',
                    roleName: '',
                    mailAddressPc: '',
                    mailAddressMb: '',
                    parentFamilyName: '',
                    parentFirstName: '',
                    status: '',
                    updateDatetime: '',
                    condominiumGroupName: '',
                    condominiumCd: '',
                    condominiumName: '',
                },
                selectedRoomToResidentInfos: [],
                setHandoverCondominiumGroup: null,
                handoverCondominiumGroupId: null,
                handoverCondominiumGroupName: null,
                endDateOfHandover: null,
            })
        }
        if (event.target.value === ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value ||
            event.target.value === ROLE_FOR_ADMINISTRATOR.CALL_CENTER.value ||
            event.target.value === ROLE_FOR_ADMINISTRATOR.OFFICE_CENTER_OWNERSHIP_TRANSFER.value
        ) {
            this.setState({
                selectedResidentUserInfo: {
                    sutekiNetId: '',
                    seq: 0,
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    adminFamilyName: '',
                    adminFirstName: '',
                    parentAdminFamilyName: '',
                    parentAdminFirstName: '',
                    roleName: '',
                    mailAddressPc: '',
                    mailAddressMb: '',
                    parentFamilyName: '',
                    parentFirstName: '',
                    status: '',
                    updateDatetime: '',
                    condominiumGroupName: '',
                    condominiumCd: '',
                    condominiumName: '',
                },
                selectedRoomToResidentInfos: [],
                selectedCondominiumCd: '',
                selectedCondominiumName: '',
                setHandoverCondominiumGroup: null,
                handoverCondominiumGroupId: null,
                handoverCondominiumGroupName: null,
                endDateOfHandover: null,
            })
        }
        if (event.target.value === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value
        ) {
            this.setState({
                selectedResidentUserInfo: {
                    sutekiNetId: '',
                    seq: 0,
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    adminFamilyName: '',
                    adminFirstName: '',
                    parentAdminFamilyName: '',
                    parentAdminFirstName: '',
                    roleName: '',
                    mailAddressPc: '',
                    mailAddressMb: '',
                    parentFamilyName: '',
                    parentFirstName: '',
                    status: '',
                    updateDatetime: '',
                    condominiumGroupName: '',
                    condominiumCd: '',
                    condominiumName: '',
                },
                selectedRoomToResidentInfos: [],
                selectedCondominiumCd: '',
                selectedCondominiumName: '',
                setHandoverCondominiumGroup: DO_OR_NOT.NOT.value,
                handoverCondominiumGroupId: null,
                handoverCondominiumGroupName: null,
                endDateOfHandover: null,
            })
        }
    }

    async handleChangeSetHandoverCondominiumGroup(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        const setHandoverCondominiumGroup = event.target.value
        if (setHandoverCondominiumGroup === DO_OR_NOT.DO.value) {

            const currentDate = this.state.currentDate!.clone()
            const defaultDate = new Date(currentDate!.add(2, 'month').endOf('month').format('YYYY-MM-DD'))
            this.setState({
                setHandoverCondominiumGroup: setHandoverCondominiumGroup,
                handoverCondominiumGroupId: this.state.loginUserCondominiumGroupId,
                endDateOfHandover: defaultDate,
            })
        } else {
            this.setState({
                setHandoverCondominiumGroup: setHandoverCondominiumGroup,
                handoverCondominiumGroupId: null,
                endDateOfHandover: null,
            })
        }
    }

    handleChangeHandoverCondominiumGroupId(
        handoverCondominiumGroupId: number,
        handoverCondominiumGroupName?: string): void {
        this.setState({
            handoverCondominiumGroupId: handoverCondominiumGroupId,
            handoverCondominiumGroupName: handoverCondominiumGroupName ? handoverCondominiumGroupName : '',
        })
    }

    handleChangeEndDateOfHandover(date: Nullable<Date>): void {
        if (date) {
            const endDateOfHandoverMoment = moment(date.toISOString())
            this.setState({
                endDateOfHandover: new Date(endDateOfHandoverMoment.endOf('month').format('YYYY-MM-DD')),
            })
        } else {
            this.setState({
                endDateOfHandover: null,
            })
        }
    }

    onCompositionStartFamilyName(): void {
        this.setState({
            convertFamilyNameKana: '',
            preFamilyNameKana: this.state.familyNameKanaValue ?? '',
        })
    }

    onCompositionUpdateFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFamilyNameKana: this.state.preFamilyNameKana + kana})
        })
    }

    onCompositionStartFirstName(): void {
        this.setState({
            convertFirstNameKana: '',
            preFirstNameKana: this.state.firstNameKanaValue ?? '',
        })
    }

    onCompositionUpdateFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFirstNameKana: this.state.preFirstNameKana + kana})
        })
    }

    handleChangeFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            familyNameValue: event.target.value,
            familyNameKanaValue: event.target.value ? this.state.convertFamilyNameKana : '',
        })
    }

    handleChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            firstNameValue: event.target.value,
            firstNameKanaValue: event.target.value ? this.state.convertFirstNameKana : '',
        })
    }

    handleChangeFamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({familyNameKanaValue: event.target.value})
    }

    handleChangeFirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({firstNameKanaValue: event.target.value})
    }

    handleChangeLoginAvailability(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({loginAvailability: event.target.value})
    }

    handleChangeTermStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({
                minTermEndDate: formatForDateInput(date.toString()),
                termStartDate: formatForDateInput(date.toString()),
            })
        } else {
            this.setState({
                minTermEndDate: '',
                termStartDate: '',
            })
        }
    }

    handleChangeTermEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({
                maxTermStartDate: formatForDateInput(date.toString()),
                termEndDate: formatForDateInput(date.toString()),
            })
        } else {
            this.setState({
                maxTermStartDate: '',
                termEndDate: '',
            })
        }
    }

    handleChangeSelectedCondominiumGroupId(condominiumGroupId: number, condominiumGroupName?: string): void {
        this.setState({
            selectedCondominiumGroupId: condominiumGroupId,
            selectedCondominiumGroupName: condominiumGroupName ? condominiumGroupName : '',
        })

        // 物件グループを変更する度に選択した物件・居住者を初期化する
        this.setState({
            selectedCondominiumCd: '',
            selectedCondominiumName: '',
            selectedRoomToResidentInfos: [],
        })
    }

    closeSelectCondominiumDiaLog(): void {
        this.setState({dialogOpenSelectCondominium: false})
    }

    closeSelectResidentUserDiaLog(): void {
        this.setState({dialogOpenSelectResidentUser: false})
    }

    getRoleMasterRadioGroupData(): PPRadioItemProp[] {
        return ROLE_FOR_ADMINISTRATOR.values()
            .filter(role => role.value !== ROLE_FOR_ADMINISTRATOR.ASSOC.value)
            .map((role) => {
                return {
                    label: role.label,
                    value: role.value,
                    radioProps: {
                        autoFocus: role.value === this.state.roleId,
                        checked: role.value === this.state.roleId,
                    },
                }
            })
    }

    handleOpenCondominiumSelectionDialog(): void {
        this.setState({
            dialogOpenSelectCondominium: true,
            selectedResidentUserInfo: {
                sutekiNetId: '',
                seq: 0,
                ridgeCd: '',
                ridgeName: '',
                roomNumber: '',
                familyName: '',
                firstName: '',
                adminFamilyName: '',
                adminFirstName: '',
                parentAdminFamilyName: '',
                parentAdminFirstName: '',
                roleName: '',
                mailAddressPc: '',
                mailAddressMb: '',
                parentFamilyName: '',
                parentFirstName: '',
                status: '',
                updateDatetime: '',
                condominiumGroupName: '',
                condominiumCd: '',
                condominiumName: '',
            },
            selectedRoomToResidentInfos: [],
        })
    }

    async handleOpenResidentUserSelectionDialog(): Promise<void> {
        const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
            this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        if (currentDateTime && currentDateTime.details) {
            this.setState({
                currentDate: moment(currentDateTime.details.currentDateTime),
            })
        }

        if (this.state.selectedCondominiumCd) {
            this.setState({
                dialogOpenSelectResidentUser: true,
            })
        }
    }

    handleChangeSelectedCondominiumInfo(selectedCondominiumInfo: CondominiumInfo): void {
        this.setState({
            selectedCondominiumCd: selectedCondominiumInfo.condominiumCd,
            selectedCondominiumName: selectedCondominiumInfo.condominiumName,
            dialogOpenSelectCondominium: false,
        })
    }

    async handleChangeSelectedResidentUserInfo(selectedResidentUserInfo: ResidentUserInfo): Promise<void> {
        if (selectedResidentUserInfo.sutekiNetId) {
            const flpAdminUserInfo: Nullable<NatGetOwnerCondominium> = await this.props.asyncCallFunction(
                this.props.ownerCondominiumRepo.getOwnerCondomoinum.bind(
                    this.props.ownerCondominiumRepo,
                    selectedResidentUserInfo.sutekiNetId,
                    selectedResidentUserInfo.condominiumCd,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (flpAdminUserInfo && flpAdminUserInfo.details) {
                this.setState({selectedRoomToResidentInfos: flpAdminUserInfo.details.roomToResident})
            } else {
                return
            }
        } else {
            const invalidResident: RoomToResident[] = [{
                ridgeCd: selectedResidentUserInfo.ridgeCd,
                ridgeName: selectedResidentUserInfo.ridgeName,
                roomNumber: selectedResidentUserInfo.roomNumber,
                adminFamilyName: selectedResidentUserInfo.adminFamilyName ? selectedResidentUserInfo.adminFamilyName : '',
                adminFirstName: selectedResidentUserInfo.adminFirstName ? selectedResidentUserInfo.adminFirstName : '',
                parentAdminFamilyName: selectedResidentUserInfo.parentAdminFamilyName ?
                    selectedResidentUserInfo.parentAdminFamilyName : '',
                parentAdminFirstName: selectedResidentUserInfo.parentAdminFirstName ?
                    selectedResidentUserInfo.parentAdminFirstName : '',
            }]
            this.setState({selectedRoomToResidentInfos: invalidResident})
        }
        this.setState({
            selectedResidentUserInfo: selectedResidentUserInfo,
            dialogOpenSelectResidentUser: false,
        })
    }

    renderSelectedCondominiumInfo(condominiumCd: string, condominiumName: string): ReactNode {
        if (!condominiumCd || !condominiumName) {
            return (<></>)
        } else {
            return (
                <>
                    <SelectedFlexWrapperWide>
                        <SelectedModalInfoItemLabel>物件コード</SelectedModalInfoItemLabel>
                        <SelectedModalInfoItemValue>{condominiumCd}</SelectedModalInfoItemValue>
                    </SelectedFlexWrapperWide>
                    <SelectedFlexWrapperLong>
                        <SelectedModalInfoItemLabel>物件名</SelectedModalInfoItemLabel>
                        <SelectedModalInfoItemValueCondominium>{condominiumName}</SelectedModalInfoItemValueCondominium>
                    </SelectedFlexWrapperLong>
                </>
            )
        }
    }

    renderSelectedResidentUserInfo(ownerCondominiumInfos: RoomToResident[]): ReactNode {
        if (ownerCondominiumInfos.length === 0) {
            return (<></>)
        }
        const roomInfos: string[] = []
        const adminName: string[] = []
        ownerCondominiumInfos.map((ownerCondominiumInfo) => {
            roomInfos.push((ownerCondominiumInfo.ridgeName ? ownerCondominiumInfo.ridgeName : '') + ' ' +
                (ownerCondominiumInfo.roomNumber ? ownerCondominiumInfo.roomNumber : ''))
            if (ownerCondominiumInfo.parentAdminFamilyName !== null) {
                adminName.push((ownerCondominiumInfo.parentAdminFamilyName ?
                        ownerCondominiumInfo.parentAdminFamilyName : '') + ' ' +
                    (ownerCondominiumInfo.parentAdminFirstName ?
                        ownerCondominiumInfo.parentAdminFirstName : ''))
            } else {
                adminName.push((ownerCondominiumInfo.adminFamilyName ?
                        ownerCondominiumInfo.adminFamilyName : '') + ' ' +
                    (ownerCondominiumInfo.adminFirstName ?
                        ownerCondominiumInfo.adminFirstName : ''))
            }
        })


        return (
            <>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>部屋番号</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValue>{roomInfos.join(',')}</SelectedModalInfoItemValue>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {(this.state.selectedResidentUserInfo.familyName ||
                            this.state.selectedResidentUserInfo.firstName) ?
                            this.state.selectedResidentUserInfo.familyName + ' ' +
                            this.state.selectedResidentUserInfo.firstName : ''
                        }
                    </SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>管理者確認用氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {adminName.join(',')}</SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
            </>
        )
    }

    renderInputFormTable(): ReactNode {
        const passwordRequired = this.state.roleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
            this.state.roleId === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value ||
            this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value

        return (
            <>
                <ConditionTableFixed>
                    <colgroup>
                        <col width={'25%'}/>
                        <col width={'10%'}/>
                        <col width={'25%'}/>
                        <col width={'10%'}/>
                        <col width={'30%'}/>
                    </colgroup>
                    <StyledTableCaption>管理者ユーザ情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName required>権限</TableRowName>
                            <TableCell colSpan={4}>
                                <PPRadioGroup
                                    row
                                    data={this.getRoleMasterRadioGroupData()}
                                    eventKeys={['roleId']}
                                    onChange={this.handleChangeRole}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>物件グループを選択</TableRowName>
                            <TableCell colSpan={4}>
                                {
                                    this.state.condominiumGroup &&
                                    this.state.condominiumGroup.details &&
                                    <NatCondominiumGroupSelectComponent
                                        condominiumGroup={this.state.condominiumGroup.details}
                                        defaultValue={this.state.registeredAdminUserData.condominiumGroupId}
                                        onChangeSelectedCondominiumGroupId={
                                            this.handleChangeSelectedCondominiumGroupId}
                                        requiredFlag={true}
                                        eventKeys={['condominiumGroupId']}
                                        eventEmitter={this.props.eventEmitter}
                                    >
                                    </NatCondominiumGroupSelectComponent>
                                }
                            </TableCell>
                        </TableRow>
                        {(() => {
                            if (this.state.roleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
                                this.state.roleId === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value ||
                                this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value
                            ) {
                                return (
                                    <TableRow>
                                        <TableRowName required>物件を選択</TableRowName>
                                        <TableCell colSpan={4}>
                                            <RowFlexContainer>
                                                <SelectedFlexWrapper>
                                                    <PPErrorDisplayButton
                                                        disabled={false}
                                                        size={'small'}
                                                        eventEmitter={this.props.eventEmitter}
                                                        eventKeys={['condominiumCd']}
                                                        onClick={this.handleOpenCondominiumSelectionDialog}
                                                        clearError={true}
                                                    >
                                                        選択する
                                                    </PPErrorDisplayButton>
                                                </SelectedFlexWrapper>
                                                {this.renderSelectedCondominiumInfo(
                                                    this.state.selectedCondominiumCd,
                                                    this.state.selectedCondominiumName,
                                                )}
                                            </RowFlexContainer>
                                        </TableCell>

                                    </TableRow>
                                )
                            }
                        })()}
                        {this.state.dialogOpenSelectCondominium && this.state.condominiumGroup.details &&
                            <NatCondominiumSelectionComponent
                                selectedCondominiumGroupId={this.state.selectedCondominiumGroupId}
                                selectCondominiumType={SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value}
                                condominiumRepo={this.props.condominiumRepo}
                                condominiumGroupRepo={this.props.condominiumGroupRepo}
                                closeSelectCondominiumDiaLog={this.closeSelectCondominiumDiaLog}
                                setSelectedCondominiumInfo={this.handleChangeSelectedCondominiumInfo}
                                eventEmitter={this.props.eventEmitter}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value &&
                            <>
                                <TableRow>
                                    <TableRowName required>
                                        居住者ユーザを選択
                                    </TableRowName>
                                    <TableCell colSpan={4}>
                                        <RowFlexContainer>
                                            <SelectedFlexWrapper>
                                                <PPErrorDisplayButton
                                                    disabled={
                                                        !this.state.selectedCondominiumCd
                                                    }
                                                    size={'small'}
                                                    eventEmitter={this.props.eventEmitter}
                                                    eventKeys={['sutekiNetId']}
                                                    onClick={this.handleOpenResidentUserSelectionDialog}
                                                    clearError={true}
                                                >
                                                    選択する
                                                </PPErrorDisplayButton>
                                            </SelectedFlexWrapper>
                                            {this.renderSelectedResidentUserInfo(
                                                this.state.selectedRoomToResidentInfos)}
                                        </RowFlexContainer>
                                    </TableCell>
                                </TableRow>
                            </>
                        }
                        {this.state.dialogOpenSelectResidentUser &&
                            <NatResidentUserSelectionComponent
                                roomToResidentRepo={this.props.roomToResidentRepo}
                                ridgeRepo={this.props.ridgeRepo}
                                selectUserType={SELECT_USER_TYPE.USER.value}
                                closeSelectResidentUserDiaLog={this.closeSelectResidentUserDiaLog}
                                setSelectedResidentUserInfo={this.handleChangeSelectedResidentUserInfo}
                                selectedCondominiumCd={this.state.selectedCondominiumCd}
                                invalidUserSelectFlag={true}
                                validPeriodCriteriaDate={this.state.currentDate}
                                eventEmitter={this.props.eventEmitter}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {this.state.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value &&
                            <TableRow>
                                <TableRowName required>引継情報を設定</TableRowName>
                                <TableCell colSpan={4}>
                                    <StyledColumnFlexContainer>
                                        <PPRadioGroup
                                            row
                                            data={[{
                                                label: DO_OR_NOT.NOT.label,
                                                value: DO_OR_NOT.NOT.value,
                                                radioProps: {
                                                    autoFocus: DO_OR_NOT.NOT.value
                                                        === this.state.setHandoverCondominiumGroup,
                                                    checked: DO_OR_NOT.NOT.value
                                                        === this.state.setHandoverCondominiumGroup,
                                                },
                                            },
                                                {
                                                    label: DO_OR_NOT.DO.label,
                                                    value: DO_OR_NOT.DO.value,
                                                    radioProps: {
                                                        autoFocus: DO_OR_NOT.DO.value
                                                            === this.state.setHandoverCondominiumGroup,
                                                        checked: DO_OR_NOT.DO.value
                                                            === this.state.setHandoverCondominiumGroup,
                                                    },
                                                }]}
                                            eventKeys={['setHandoverCondominiumGroup']}
                                            onChange={this.handleChangeSetHandoverCondominiumGroup}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                        {this.state.setHandoverCondominiumGroup === DO_OR_NOT.DO.value &&
                                            <>
                                                <label>
                                                    <StyledRowFlexContainer>
                                                        <StyledDivNoWrap>引継中物件グループ</StyledDivNoWrap>
                                                        {
                                                            this.state.condominiumGroup &&
                                                            this.state.condominiumGroup.details &&
                                                            <StyledFlexItem>
                                                                <NatCondominiumGroupSelectComponent
                                                                    condominiumGroup={
                                                                        this.state.condominiumGroup.details}
                                                                    defaultValue={this.state.handoverCondominiumGroupId
                                                                        ? this.state.handoverCondominiumGroupId
                                                                        : this.state.loginUserCondominiumGroupId}
                                                                    onChangeSelectedCondominiumGroupId={
                                                                        this.handleChangeHandoverCondominiumGroupId}
                                                                    requiredFlag={true}
                                                                    eventKeys={['handoverCondominiumGroupId']}
                                                                    eventEmitter={this.props.eventEmitter}
                                                                >
                                                                </NatCondominiumGroupSelectComponent>
                                                            </StyledFlexItem>
                                                        }
                                                    </StyledRowFlexContainer>
                                                </label>
                                                <label>
                                                    <StyledRowFlexContainer>
                                                        <StyledDivNoWrap>引継期間</StyledDivNoWrap>
                                                        <Box pl={'80px'}>
                                                            <PPDatePicker
                                                                inputType={'ym_jp'}
                                                                onChangeDate={
                                                                    this.handleChangeEndDateOfHandover}
                                                                value={(this.state.endDateOfHandover)
                                                                    ? new Date(this.state.endDateOfHandover)
                                                                    : null
                                                                }
                                                                minDate={new Date(this.state.currentDate!.format(
                                                                    'YYYY-MM-DD'))}
                                                                eventEmitter={this.props.eventEmitter}
                                                                eventKeys={['endDateOfHandover']}
                                                            />
                                                        </Box>
                                                        末まで
                                                    </StyledRowFlexContainer>
                                                </label>
                                            </>
                                        }
                                    </StyledColumnFlexContainer>
                                </TableCell>
                            </TableRow>
                        }
                        <TableRow>
                            <TableRowName required>管理者ID</TableRowName>
                            <TableCell colSpan={this.state.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value ? 2 : 4}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 10,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.loginId}
                                    onChange={this.handleChangeLoginId}
                                    eventKeys={['loginId', 'adminId']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                            {this.state.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value &&
                                <TableCell colSpan={2}>
                                    <AdminPrimaryButton
                                        onClick={this.getAzureADUser}
                                    >
                                        社員番号からユーザ情報入力
                                    </AdminPrimaryButton>
                                </TableCell>
                            }
                        </TableRow>
                        {this.state.roleId !== ROLE_FOR_ADMINISTRATOR.ASSOC.value &&
                        <TableRow>
                            <TableRowName>メールアドレス</TableRowName>
                            <TableCell colSpan={4}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 100,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.mailAddressValue}
                                    onChange={this.handleChangeMailAddress}
                                    eventKeys={['mailAddress']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        }
                        <StyledTableRow
                            hidden={this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value}>
                            <TableRowName required>氏名</TableRowName>
                            <TableCell>姓</TableCell>
                            <TableCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'familyName',
                                            id: 'familyName',
                                            maxLength: 10,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.familyNameValue}
                                    onInput={this.handleChangeFamilyName}
                                    onChange={this.handleChangeFamilyName}
                                    onCompositionStart={this.onCompositionStartFamilyName}
                                    onCompositionUpdate={this.onCompositionUpdateFamilyName}
                                    eventKeys={['familyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                            <TableCell>名</TableCell>
                            <TableCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'firstName',
                                            id: 'firstName',
                                            maxLength: 10,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.firstNameValue}
                                    onInput={this.handleChangeFirstName}
                                    onChange={this.handleChangeFirstName}
                                    onCompositionStart={this.onCompositionStartFirstName}
                                    onCompositionUpdate={this.onCompositionUpdateFirstName}
                                    eventKeys={['firstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </StyledTableRow>
                        <StyledTableRow
                            hidden={this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value}>
                            <TableRowName>氏名(フリガナ)</TableRowName>
                            <TableCell>セイ</TableCell>
                            <TableCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'familyNameKana',
                                            id: 'familyNameKana',
                                            maxLength: 20,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.familyNameKanaValue}
                                    onChange={this.handleChangeFamilyNameKana}
                                    eventKeys={['familyNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                            <TableCell>メイ</TableCell>
                            <TableCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'firstNameKana',
                                            id: 'firstNameKana',
                                            maxLength: 20,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.firstNameKanaValue}
                                    onChange={this.handleChangeFirstNameKana}
                                    eventKeys={['firstNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </StyledTableRow>
                        <TableRow>
                            <TableRowName required={passwordRequired}>パスワード</TableRowName>
                            <TableCell colSpan={4}>
                                <PPInput
                                    type="password"
                                    inputProps={{
                                        maxLength: 20,
                                    }}
                                    autoComplete={'new-password'}
                                    required
                                    fullWidth
                                    placeholder={PASSWORD_PLACEHOLDER}
                                    value={this.state.password}
                                    onChange={this.handleChangePassword}
                                    hint={Messages.HCONA0008.toString()}
                                    eventKeys={['password']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required={passwordRequired}>パスワード（確認用）</TableRowName>
                            <TableCell colSpan={4}>
                                <PPInput
                                    type="password"
                                    inputProps={{
                                        maxLength: 20,
                                    }}
                                    autoComplete={'new-password'}
                                    required
                                    fullWidth
                                    value={this.state.passwordConfirm}
                                    placeholder={PASSWORD_PLACEHOLDER}
                                    onChange={this.handleChangePasswordConfirm}
                                    eventKeys={['passwordConfirm']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>任期開始日</TableRowName>
                            <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 22}}>
                                <PPDatePicker
                                    onChangeDate={this.handleChangeTermStartDate}
                                    value={(this.state.termStartDate) ?
                                        new Date(this.state.termStartDate) : null
                                    }
                                    eventEmitter={this.props.eventEmitter}
                                    eventKeys={['termStartDate']}
                                    maxDate={(this.state.maxTermStartDate !== '') ?
                                        new Date(this.state.maxTermStartDate) : undefined
                                    }
                                />
                            </TableCell>
                            <TableRowName>任期終了日</TableRowName>
                            <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 22}}>
                                <PPDatePicker
                                    onChangeDate={this.handleChangeTermEndDate}
                                    value={(this.state.termEndDate) ?
                                        new Date(this.state.termEndDate) : null
                                    }
                                    eventEmitter={this.props.eventEmitter}
                                    eventKeys={['termEndDate']}
                                    minDate={(this.state.minTermEndDate !== '') ?
                                        new Date(this.state.minTermEndDate) : undefined
                                    }
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>ログイン可否</TableRowName>
                            <TableCell colSpan={4}>

                                <PPRadioGroup
                                    row
                                    data={AVAILABLE_OR_NOT.values()}
                                    defaultValue={this.state.registeredAdminUserData.loginAvailability}
                                    onChange={this.handleChangeLoginAvailability}
                                    eventKeys={['loginAvailability']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </ConditionTableFixed>
            </>
        )
    }

    changeAcceptedWarnings(acceptAll: boolean): void {
        this.setState({
            warningChecked: acceptAll,
        })
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgementDispPutAdminUserButton()}
                        onClick={this.putAdminUserButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/adminUser/${this.props.adminId}`,
                        )}
                    >
                        管理者ユーザ詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <NatAdminCommonAcceptedWarningComponent
                    title={'ご確認ください'}
                    description={'メールアドレスが入力されていません。'}
                    warnings={this.state.warning}
                    changeAcceptedWarnings={this.changeAcceptedWarnings}
                    doOpenAnimation={true}/>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }
}

export const SelectedModalInfoItemLabel: StyledSpan = styled.span`
  font-size: smaller;
  white-space: nowrap;
  margin-left: 20px;
  margin-right: 20px;
`

export const SelectedModalInfoItemValue: StyledSpan = styled.span`
  font-weight: bolder;
  white-space: normal;
  margin-right: 20px;
`

export const SelectedModalInfoItemValueCondominium = styled(SelectedModalInfoItemValue)`
  margin-right: 0;
  white-space: normal;
  word-break: break-all;
`

const SelectedFlexWrapper = styled.div`
  display: flex;
  padding-right: 15px;
  flex: 1 1 0%;
  align-items: center;
`

const SelectedFlexWrapperWide = styled(SelectedFlexWrapper)`
  flex-grow: 2;
`

const SelectedFlexWrapperLong = styled(SelectedFlexWrapper)`
  flex-grow: 5;
`

export default createAdminPage(NatAdminAdminUserEditPage)

const StyledTableRow = styled(TableRow)<{ hidden?: boolean }>`
  &.MuiTableRow-root {
    visibility: ${props => props.hidden ? 'collapse' : 'visible'};
  }
`

const StyledColumnFlexContainer: StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

const StyledRowFlexContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

const StyledFlexItem = styled.div`
  width: 100%;
  padding-left: 10px;
`

const StyledDivNoWrap = styled.div`
  white-space: nowrap;
`
